import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FaqModel } from '../models/faq.model';
import { ConfigurationService } from '../shared/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class FaqsService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  
  private backUrl;
  
  constructor() {
    this.backUrl = `${this.configSvc.faqsApiUrl}api`;
  }

  setBackUrl(url: string) {
    this.backUrl = `${this.configSvc.faqsApiUrl}api/${url}`;
  }

  post(model: FaqModel): Observable<any> {
    return this.http.post(`${this.backUrl}`, model);
  }

  getTree(onlyActives: boolean): Observable<Array<FaqModel>> {
    return this.http.get<Array<FaqModel>>(`${this.backUrl}?onlyActives=${onlyActives}`);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.backUrl}/${id}`);
  }

  update(model: FaqModel): Observable<any> {
    return this.http.patch(`${this.backUrl}/${model.id}`, model);
  }

  active(faqId: string, newStatus: boolean): Observable<any> {
    return this.http.patch(`${this.backUrl}/${faqId}/active`, { isActive: newStatus });
  }
}
